import React from 'react';
import PropTypes from 'prop-types';
import './reader.css';

class Reader extends React.Component {
  render() {
    return (
      <div className="reader-modal">
        <div className="reader-modal__inner">
          <div className="reader-modal__close" onClick={this.props.hideReader}>
            Закрыть
          </div>
          <div
            className="reader-modal__header"
            dangerouslySetInnerHTML={{__html: this.props.readerName}}
            onClick={this.props.hideReader}
          />
          <div className="reader-modal__text-container">
            <div
              className="reader-modal__text"
              dangerouslySetInnerHTML={{__html: this.props.readerText}}
            />
          </div>
        </div>
      </div>
    );
  }
}

Reader.propTypes = {
  hideReader: PropTypes.func,
  readerName: PropTypes.string,
  readerText: PropTypes.string
};

export default Reader;
